module.exports = __webpack_public_path__ + "img/coin-background.9188c8a1.png";